"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withRoutes = exports.useApplicationRoutes = exports.default = exports.TrackPageview = exports.RouteContext = exports.RouteConsumer = exports.Route = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _ScrollToTop = _interopRequireDefault(require("../../utils/ScrollToTop"));

var _urlParamsHelper = _interopRequireDefault(require("../../utils/urlParams/urlParamsHelper"));

var _ReloadOnVersionChange = require("../../utils/ReloadOnVersionChange");

var _analytics = require("@jobmatchme/frontend-analytics/es/analytics");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* Context */
var RouteContext = /*#__PURE__*/_react.default.createContext({});
/* Helper */


exports.RouteContext = RouteContext;
var urlParamsHelper = new _urlParamsHelper.default();
/**
 * Global Route variant provider
 *
 **/

var RouteProvider = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(RouteProvider, _React$Component);

  var _super = _createSuper(RouteProvider);

  function RouteProvider(props) {
    var _this;

    (0, _classCallCheck2.default)(this, RouteProvider);
    _this = _super.call(this, props);

    _this.generatePath = function (path) {
      var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'de';
      var host = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return path['global'] ? "".concat(path['global']) : "".concat(host ? host : '').concat(locale && '/').concat(locale).concat(path[locale]);
    };

    _this.registerRoute = function (id, path) {
      _this.setState((0, _extends3.default)({}, _this.state, {
        routes: (0, _extends3.default)({}, _this.state.routes, (0, _defineProperty2.default)({}, id, path || null))
      }));
    };

    _this.renderRoutes = function () {
      return _react.default.Children.map(_this.props.children, function (child) {
        return child && (0, _typeof2.default)(child) === 'object' && 'props' in child && !child.props.staticPath ? /*#__PURE__*/_react.default.cloneElement(child, {
          path: _this.generatePath(child.props.path, _this.state.locale)
        }) : undefined;
      });
    };

    _this.packagesToWatchForVersionChange = {
      'pc-matching': ['app'],
      'bc-dashboard': ['app']
    };
    _this.Router = _this.props.router || _reactRouterDom.BrowserRouter;
    var STAGE = process.env.REACT_APP_STAGE === 'prod' ? 'www' : 'stage';

    var _host = "https://".concat(STAGE, ".truck-jobs.com");

    var routes = {
      // Default routes, that lead to the core jmm system
      pcreg: "".concat(_host, "/employee/jobsearch").concat(props.locale && '?locale=' + props.locale),
      bcreg: "".concat(_host, "/employer/registration").concat(props.locale && '?locale=' + props.locale),
      imprint: "".concat(_host, "/imprint/"),
      legal: "".concat(_host, "/legal/"),
      privacy: "".concat(_host, "/privacy/"),
      faq: "".concat(_host, "/de/faqs/"),
      bcfaq: "https://jobmatch.me/de-de/arbeitgeber/haeufige-fragen-zu-jobmatchme/",
      news: "".concat(_host, "/de/wissen/"),
      newsPc: "".concat(_host, "/de/wissen/fahrer/"),
      newsBc: "".concat(_host, "/de/wissen/arbeitgeber/"),
      pcPage: "".concat(_host, "/").concat(props.locale, "/"),
      bcPage: "".concat(_host, "/de/arbeitgeber/"),
      successStoriesList: "".concat(_host, "/de/erfahrungen/"),
      carePcLogin: "".concat(_host, "/de/jobs/pflege/suche/login/"),
      pl_pcLogin: "/pl/login/",
      de_pcLogin: "/de/login/",
      at_pcLogin: "/de/login/",
      pl_bcLogin: "/pl/pracodawca/app/login/",
      de_bcLogin: "/de/arbeitgeber/app/login/",
      at_bcLogin: "/de/arbeitgeber/app/login/"
    }; // We need to prefix the routes with the locale, if given

    _react.default.Children.map(props.children, function (route) {
      routes[route.props.id] = route.props.path ? _this.generatePath(route.props.path, props.locale, route.props.host).replace('*', '') : null;
    });

    _this.state = {
      locale: props.locale,
      routes: routes
    };
    urlParamsHelper.saveGetParamsToLocalStorage();
    urlParamsHelper.cleanupUrlParams();
    return _this;
  }
  /**
   * Generates a path string
   * @param {string} locale The locale prefix
   * @param {string} path   The actual path
   */


  (0, _createClass2.default)(RouteProvider, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(this.Router, {
        location: this.props.location,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(RouteContext.Provider, {
          value: (0, _extends3.default)({}, this.state.routes, {
            _locale: this.state.locale
          }),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ReloadOnVersionChange.ReloadOnVersionChange, {
            packagesWithRoutes: this.packagesToWatchForVersionChange,
            packageVersions: this.props.packageVersions,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(TrackPageview, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScrollToTop.default, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactRouterDom.Routes, {
                  children: [this.renderRoutes(), !this.props.no404 && /*#__PURE__*/(0, _jsxRuntime.jsx)(Route, {
                    path: "*",
                    children: this.props.notFoundPage || null
                  })]
                })
              })
            })
          })
        })
      });
    }
  }]);
  return RouteProvider;
}(_react.default.Component);
/**
 * Custom route component
 * @param {string}  id    The identifier for the route
 * @param {string}  path  The path to route to
 */


var Route = _reactRouterDom.Route;
/**
 * The consumer component for the RouteContext
 **/

exports.Route = Route;
var RouteConsumer = RouteContext.Consumer;
/**
 * HOC that provides the globalApplicationRoutes Prop
 */

exports.RouteConsumer = RouteConsumer;

var withRoutes = function withRoutes(Component) {
  return function (props) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(RouteConsumer, {
      children: function children(routes) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, (0, _extends3.default)({
          applicationRoutes: routes,
          getUrlParams: urlParamsHelper.getUrlParamsFromLocalStorage
        }, props));
      }
    });
  };
};

exports.withRoutes = withRoutes;

var TrackPageview = function TrackPageview(_ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'variant' : _ref$variant;
  var location = (0, _reactRouterDom.useLocation)();
  (0, _react.useEffect)(function () {
    var experimentId = null;
    var experimentVariant = undefined;

    if (localStorage.getItem(variant)) {
      experimentId = localStorage.getItem(variant);
    }

    (0, _analytics.trackPageview)({
      page: location.pathname + location.search,
      experimentId: experimentId,
      experimentVariant: experimentVariant
    });
  }, [location, variant]);
  return children;
};

exports.TrackPageview = TrackPageview;

var useApplicationRoutes = function useApplicationRoutes() {
  return (0, _react.useContext)(RouteContext);
};

exports.useApplicationRoutes = useApplicationRoutes;
var _default = RouteProvider;
exports.default = _default;